import storage from "../utils/storage";

export function loadClientSettings() {
    const {hostname} = window.location;
    const fullWidth = storage.getItem('full_width') === 'true' || hostname.includes("patriots.win");
    return { fullWidth };
}

export function saveClientSettings(settings) {
    storage.setItem('full_width', Boolean(settings.fullWidth).toString());
}
